import { createRouter, createWebHistory } from "vue-router";

import pinia from "@/pinia";
import { useAccountStore } from "@/store/account";

import LoginDash from "@/components/login/userlogin.vue";
import User from "@/components/main/maindashboard.vue";
import Agen from "@/components/main/agendashboard.vue";
import DataIsian from "@/components/main/DataIsian.vue";
import UserRegis from "@/components/login/userregis.vue";

import { getCookie } from "@/assets/config/cookie";

/*
|--------------------------------------------------------------------------
| ROUTES
|--------------------------------------------------------------------------
*/

const routes = [
    {
        path: "/",
        name: "Login",
        component: LoginDash,
    },

    {
        path: "/regis",
        name: "Regis",
        component: UserRegis,
    },

    {
        path: "/user",
        name: "User",
        component: User,
        meta: {
            requiresAuth: true,
            roles: ["Perusahaan"],
        },
    },

    {
        path: "/user/dataisian",
        name: "DataIsian",
        component: DataIsian,
        meta: {
            requiresAuth: true,
            roles: ["Perusahaan"],
        },
    },

    {
        path: "/agen",
        name: "Agen",
        component: Agen,
        meta: {
            requiresAuth: true,
            roles: ["Agent", "Supervisor"],
        },
    },
];

/*
|--------------------------------------------------------------------------
| ROUTER
|--------------------------------------------------------------------------
*/

const router = createRouter({
    history: createWebHistory(),
    routes,
});

/*
|--------------------------------------------------------------------------
| ROUTER GUARD
|--------------------------------------------------------------------------
*/

router.beforeEach(async (to) => {

    const account = useAccountStore(pinia);

    /*
    |--------------------------------------------------------------------------
    | COOKIE AGENT / SUPERVISOR
    |--------------------------------------------------------------------------
    */

    const cookie = getCookie("loginInfo");

    let accountAgent = null;

    if (cookie) {
        try {
            accountAgent = JSON.parse(cookie);
        } catch (error) {
            console.error(
                "Cookie loginInfo tidak valid:",
                error
            );

            accountAgent = null;
        }
    }

    /*
    |--------------------------------------------------------------------------
    | REGISTRASI
    |--------------------------------------------------------------------------
    |
    | /regis boleh diakses siapa saja.
    |
    */

    if (to.name === "Regis") {
        return true;
    }


    /*
    |--------------------------------------------------------------------------
    | AMBIL ROLE PERUSAHAAN
    |--------------------------------------------------------------------------
    */

    const isPerusahaan =
        account.isLoggedIn === true &&
        account.role === "Perusahaan";


    /*
    |--------------------------------------------------------------------------
    | CEK STATUS DATA PERUSAHAAN
    |--------------------------------------------------------------------------
    */

    const dataPerusahaanLengkap =
        isPerusahaan &&
        account.perusahaan?.status === true;


    /*
    |--------------------------------------------------------------------------
    | CEK AGENT / SUPERVISOR
    |--------------------------------------------------------------------------
    */

    let agentRole = null;

    if (accountAgent) {

        agentRole =
            accountAgent.role ??
            accountAgent.user?.role ??
            accountAgent.role_name;

    }


    const isAgent =
        agentRole === "Agent" ||
        agentRole === "Supervisor";


    /*
    |--------------------------------------------------------------------------
    | ROUTE LOGIN "/"
    |--------------------------------------------------------------------------
    */

    if (to.name === "Login") {

        /*
         * PERUSAHAAN SUDAH LOGIN
         */

        if (isPerusahaan) {

            /*
             * Data perusahaan sudah lengkap
             */

            if (dataPerusahaanLengkap) {

                return {
                    name: "User",
                };
            }


            /*
             * Data perusahaan belum lengkap
             */


            return {
                name: "DataIsian",
            };
        }


        /*
         * AGENT / SUPERVISOR SUDAH LOGIN
         */

        if (isAgent) {

            return {
                name: "Agen",
            };
        }


        /*
         * BELUM LOGIN
         */

        return true;
    }


    /*
    |--------------------------------------------------------------------------
    | ROUTE PUBLIC LAINNYA
    |--------------------------------------------------------------------------
    */

    if (!to.meta.requiresAuth) {
        return true;
    }


    /*
    |--------------------------------------------------------------------------
    | PERUSAHAAN
    |--------------------------------------------------------------------------
    */

    if (isPerusahaan) {

        /*
         * Perusahaan hanya boleh masuk
         * ke route yang memiliki role Perusahaan
         */

        const allowed =
            to.meta.roles?.includes("Perusahaan");


        if (allowed) {

            /*
             * Khusus /user
             *
             * Kalau data belum lengkap,
             * jangan boleh masuk dashboard.
             */

            if (to.name === "User") {

                if (dataPerusahaanLengkap) {
                    return true;
                }

                return {
                    name: "DataIsian",
                };
            }


            /*
             * /user/dataisian
             *
             * Tetap boleh diakses walaupun
             * status perusahaan false.
             */

            if (to.name === "DataIsian") {
                return true;
            }


            return true;
        }


        /*
         * Perusahaan mencoba masuk ke route Agent
         */

        if (dataPerusahaanLengkap) {

            return {
                name: "User",
            };
        }

        return {
            name: "DataIsian",
        };
    }


    /*
    |--------------------------------------------------------------------------
    | AGENT / SUPERVISOR
    |--------------------------------------------------------------------------
    */

    if (isAgent) {

        /*
         * Cek apakah role boleh mengakses route
         */

        if (
            to.meta.roles?.includes(agentRole)
        ) {

            return true;
        }


        /*
         * Agent/Supervisor mencoba masuk
         * ke route yang bukan miliknya
         */

        return {
            name: "Agen",
        };
    }


    /*
    |--------------------------------------------------------------------------
    | TIDAK LOGIN
    |--------------------------------------------------------------------------
    */

    return {
        name: "Login",
    };
});

export default router;
